import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventAbout extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventAbout';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            html_content: '',
        }
    }
}

const servicePath = 'f-about';
const servicePlugin = makeServicePlugin({
    Model: EventAbout,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin
